import { ObjectTypeSysname } from "../types";
import { DictionaryTypeAlias } from "../types/DictionaryTypeAlias";
import buildUrl from "../utils/buildUrl";
import { baseUrl } from "./baseUrl";

export const getObjectTypesRoute = (objectTypeSysname?: ObjectTypeSysname) =>
  buildUrl({
    url: [baseUrl, "dict-api", "object-types", objectTypeSysname].filter(Boolean).join("/"),
  });

export const getDictByTypeRoute = (dicTypeAlias: DictionaryTypeAlias) =>
  buildUrl({ url: `${baseUrl}/dict-api/dictionaries/${dicTypeAlias}` });

export const getDicByObjectType = (objType) =>
  buildUrl({ url: `${baseUrl}/dict-api/dictionaries/${objType}` });

export const fetchDictionariesRoute = (props?: {
  types?: DictionaryTypeAlias[];
  onDate?: string;
}) => {
  const searchParams = props
    ? {
        type: props.types,
        onDate: props.onDate,
      }
    : {};
  return buildUrl({
    url: [baseUrl, "dict-api", "dictionaries"].join("/"),
    searchParams,
  });
};

export const postDictionaryRoute = () =>
  buildUrl({
    url: [baseUrl, "dict-api", "dictionaries"].join("/"),
  });

export const fetchDictionaryTypesRoute = () =>
  buildUrl({
    url: [baseUrl, "dict-api", "dictionary-types"].join("/"),
  });

export const fetchDictionaryRoute = (props: {
  dicTypeAlias: DictionaryTypeAlias;
  includeClosed?: boolean;
  onDate?: string;
}) => {
  const { dicTypeAlias, ...searchParams } = props;
  return buildUrl({
    url: [baseUrl, "dict-api", "dictionaries", dicTypeAlias].join("/"),
    searchParams: { ...searchParams },
  });
};

export const fetchTerminVersionsRoute = ({
  dicTypeAlias,
  id,
}: {
  dicTypeAlias: DictionaryTypeAlias;
  id: number;
}) =>
  buildUrl({
    url: [baseUrl, "dict-api", "dictionaries", dicTypeAlias, id, "versions"].join("/"),
  });

export const deleteTerminVersionRoute = ({
  dicTypeAlias,
  id,
  fromDate,
}: {
  id: number;
  dicTypeAlias: DictionaryTypeAlias;
  fromDate: string;
}) =>
  buildUrl({
    url: [baseUrl, "dict-api", "dictionaries", dicTypeAlias, id].join("/"),
    searchParams: { fromDate },
  });

export const updateTerminVersionRoute = (fromDate: string) =>
  buildUrl({
    url: [baseUrl, "dict-api", "dictionaries"].join("/"),
    searchParams: { fromDate },
  });

export const createContentMetaData = () => buildUrl({ url: `${baseUrl}/dict-api/content` });

export const createContentFileData = (id) =>
  buildUrl({ url: `${baseUrl}/dict-api/content/${id}/data` });

export const deleteContentFileData = (id) => buildUrl({ url: `${baseUrl}/dict-api/content/${id}` });
